import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import './i18n'
import App from './App.tsx'

const rootElement = document.getElementById('root')!;
// Auth snapshots contain build-time widget states and lack the visitor's return URL,
// language and session. Mount these forms afresh instead of hydrating that snapshot.
const authPage = /^\/(tr\/)?(login|register|verify-email|forgot-password|reset-password)\/?$/.test(window.location.pathname);

const appNode = (
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

if (rootElement.hasAttribute('data-prerender-snapshot') || rootElement.querySelector('[data-blog-static="true"], [data-home-static="true"], [data-tools-static="true"]')) {
  // Build-time content omits app providers and is replaced on startup.
  // React 19 hoists its own metadata; clear the tagged fallback to avoid
  // duplicate canonicals/descriptions and a stale schema after navigation.
  document.head.querySelectorAll('[data-page-static-head], [data-blog-static-head], [data-home-static-head], [data-tools-static-head]').forEach(node => node.remove());
  createRoot(rootElement).render(appNode);
} else if (rootElement.hasChildNodes() && !authPage) {
  hydrateRoot(rootElement, appNode);
} else {
  createRoot(rootElement).render(appNode);
}
